import React from 'react';
import useCondition from '../../../useCondition';
import useFilterModalContext from '../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {usePoolQuery} from 'api';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  const {data: {pool: {leadSources = []} = {}} = {}} = usePoolQuery({
    fetchPolicy: 'cache-and-network',
  });

  if (
    !condition?.originalLeadSources ||
    !condition?.originalLeadSources.length
  ) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">初回リードソース</h4>
        <button
          onClick={() => setFilterType('originalLeadSource')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({originalLeadSources: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {condition?.originalLeadSources.find(
          (leadSource) => leadSource === '0',
        ) && (
          <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
            未設定
          </span>
        )}
        {leadSources
          .filter((leadSource) =>
            condition?.originalLeadSources.includes(leadSource.id),
          )
          .map((leadSource) => (
            <span
              key={leadSource.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {leadSource.name}
            </span>
          ))}
      </div>
    </div>
  );
};
